/*Global*/
import logo from '../assets/Logo/Logo.png';

/*Home*/
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';

/*Partners*/
import partner1 from '../assets/Partners/Partner-1.png';
import partner2 from '../assets/Partners/Partner-2.png';
import partner3 from '../assets/Partners/Partner-3.png';
import partner4 from '../assets/Partners/Partner-4.png';
import partner5 from '../assets/Partners/Partner-5.png';
import partner6 from '../assets/Partners/Partner-6.png';
import partner7 from '../assets/Partners/Partner-7.png';
import partner8 from '../assets/Partners/Partner-8.png';

/*About*/ 
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';


/*Process*/ 
import step1 from '../assets/Process/Process-1.jpg';
import step2 from '../assets/Process/Process-2.jpg';
import step3 from '../assets/Process/Process-3.jpg';
import step4 from '../assets/Process/Process-4.jpg';
import step5 from '../assets/Process/Process-5.jpg';
import step6 from '../assets/Process/Process-6.jpg';


/*Pricing*/ 
import plan1 from '../assets/Pricing/Plan-1.jpg';
import plan2 from '../assets/Pricing/Plan-2.jpg';
import plan3 from '../assets/Pricing/Plan-3.jpg';


/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';


/*Testimonials*/
import testimonialImage from '../assets/Testimonials/Testimonials-Image.jpg';
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Gallery*/
import gallery1 from '../assets/Gallery/Gallery-1.jpg';
import gallery2 from '../assets/Gallery/Gallery-2.jpg';
import gallery3 from '../assets/Gallery/Gallery-3.jpg';
import gallery4 from '../assets/Gallery/Gallery-4.jpg';
import gallery5 from '../assets/Gallery/Gallery-5.jpg';
import gallery6 from '../assets/Gallery/Gallery-6.jpg';
import gallery7 from '../assets/Gallery/Gallery-7.jpg';
import gallery8 from '../assets/Gallery/Gallery-8.jpg';
import gallery9 from '../assets/Gallery/Gallery-9.jpg';


/*Careers*/
import careerIntro from '../assets/Career/Intro/Intro.jpg';
import position1 from '../assets/Career/Positions/Position-1.jpg';
import position2 from '../assets/Career/Positions/Position-2.jpg';
import position3 from '../assets/Career/Positions/Position-3.jpg';
import position4 from '../assets/Career/Positions/Position-4.jpg';
import position5 from '../assets/Career/Positions/Position-5.jpg';
import position6 from '../assets/Career/Positions/Position-6.jpg';


/*Portfolio*/
import portfolio1 from '../assets/Portfolio/Portfolio/Portfolio-1.jpg';
import portfolio1Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio1Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio1Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio1Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio1Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio1Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio2 from '../assets/Portfolio/Portfolio/Portfolio-2.jpg';
import portfolio2Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio2Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio2Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio2Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio2Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio2Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio3 from '../assets/Portfolio/Portfolio/Portfolio-3.jpg';
import portfolio3Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio3Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio3Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio3Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio3Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio3Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio4 from '../assets/Portfolio/Portfolio/Portfolio-4.jpg';
import portfolio4Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio4Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio4Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio4Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio4Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio4Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio5 from '../assets/Portfolio/Portfolio/Portfolio-5.jpg';
import portfolio5Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio5Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio5Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio5Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio5Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio5Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio6 from '../assets/Portfolio/Portfolio/Portfolio-6.jpg';
import portfolio6Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio6Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio6Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio6Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio6Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio6Gallery6 from '../assets/Portfolio/Gallery/6.jpg';


/*Vendors*/
import floral1 from '../assets/Vendor/Vendors/Floral/Floral-1.jpg';
import floral1Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import floral1Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import floral1Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import floral1Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import floral1Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import floral1Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import floral1Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import floral1Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import floral1Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import floral1Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import floral1Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import floral2 from '../assets/Vendor/Vendors/Floral/Floral-2.jpg';
import floral2Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import floral2Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import floral2Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import floral2Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import floral2Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import floral2Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import floral2Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import floral2Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import floral2Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import floral2Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import floral2Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import floral3 from '../assets/Vendor/Vendors/Floral/Floral-3.jpg';
import floral3Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import floral3Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import floral3Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import floral3Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import floral3Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import floral3Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import floral3Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import floral3Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import floral3Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import floral3Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import floral3Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import floral4 from '../assets/Vendor/Vendors/Floral/Floral-4.jpg';
import floral4Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import floral4Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import floral4Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import floral4Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import floral4Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import floral4Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import floral4Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import floral4Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import floral4Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import floral4Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import floral4Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import catering1 from '../assets/Vendor/Vendors/Catering/Catering-1.jpg';
import catering1Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import catering1Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import catering1Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import catering1Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import catering1Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import catering1Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import catering1Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import catering1Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import catering1Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import catering1Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import catering1Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import catering2 from '../assets/Vendor/Vendors/Catering/Catering-2.jpg';
import catering2Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import catering2Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import catering2Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import catering2Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import catering2Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import catering2Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import catering2Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import catering2Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import catering2Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import catering2Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import catering2Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import catering3 from '../assets/Vendor/Vendors/Catering/Catering-3.jpg';
import catering3Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import catering3Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import catering3Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import catering3Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import catering3Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import catering3Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import catering3Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import catering3Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import catering3Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import catering3Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import catering3Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import catering4 from '../assets/Vendor/Vendors/Catering/Catering-4.jpg';
import catering4Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import catering4Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import catering4Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import catering4Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import catering4Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import catering4Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import catering4Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import catering4Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import catering4Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import catering4Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import catering4Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import photography1 from '../assets/Vendor/Vendors/Photography/Photography-1.jpg';
import photography1Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import photography1Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import photography1Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import photography1Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import photography1Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import photography1Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import photography1Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import photography1Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import photography1Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import photography1Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import photography1Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import photography2 from '../assets/Vendor/Vendors/Photography/Photography-2.jpg';
import photography2Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import photography2Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import photography2Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import photography2Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import photography2Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import photography2Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import photography2Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import photography2Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import photography2Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import photography2Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import photography2Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import photography3 from '../assets/Vendor/Vendors/Photography/Photography-3.jpg';
import photography3Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import photography3Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import photography3Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import photography3Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import photography3Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import photography3Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import photography3Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import photography3Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import photography3Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import photography3Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import photography3Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import photography4 from '../assets/Vendor/Vendors/Photography/Photography-4.jpg';
import photography4Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import photography4Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import photography4Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import photography4Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import photography4Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import photography4Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import photography4Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import photography4Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import photography4Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import photography4Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import photography4Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import venue1 from '../assets/Vendor/Vendors/Venues/Venue-1.jpg';
import venue1Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import venue1Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import venue1Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import venue1Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import venue1Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import venue1Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import venue1Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import venue1Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import venue1Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import venue1Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import venue1Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import venue2 from '../assets/Vendor/Vendors/Venues/Venue-2.jpg';
import venue2Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import venue2Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import venue2Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import venue2Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import venue2Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import venue2Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import venue2Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import venue2Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import venue2Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import venue2Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import venue2Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import venue3 from '../assets/Vendor/Vendors/Venues/Venue-3.jpg';
import venue3Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import venue3Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import venue3Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import venue3Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import venue3Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import venue3Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import venue3Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import venue3Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import venue3Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import venue3Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import venue3Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import venue4 from '../assets/Vendor/Vendors/Venues/Venue-4.jpg';
import venue4Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import venue4Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import venue4Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import venue4Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import venue4Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import venue4Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import venue4Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import venue4Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import venue4Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import venue4Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import venue4Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import attire1 from '../assets/Vendor/Vendors/Attire/Attire-1.jpg';
import attire1Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import attire1Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import attire1Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import attire1Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import attire1Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import attire1Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import attire1Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import attire1Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import attire1Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import attire1Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import attire1Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import attire2 from '../assets/Vendor/Vendors/Attire/Attire-2.jpg';
import attire2Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import attire2Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import attire2Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import attire2Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import attire2Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import attire2Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import attire2Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import attire2Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import attire2Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import attire2Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import attire2Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import attire3 from '../assets/Vendor/Vendors/Attire/Attire-3.jpg';
import attire3Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import attire3Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import attire3Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import attire3Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import attire3Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import attire3Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import attire3Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import attire3Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import attire3Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import attire3Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import attire3Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import attire4 from '../assets/Vendor/Vendors/Attire/Attire-4.jpg';
import attire4Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import attire4Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import attire4Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import attire4Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import attire4Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import attire4Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import attire4Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import attire4Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import attire4Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import attire4Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import attire4Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import entertainment1 from '../assets/Vendor/Vendors/Entertainment/Entertainment-1.jpg';
import entertainment1Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import entertainment1Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import entertainment1Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import entertainment1Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import entertainment1Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import entertainment1Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import entertainment1Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import entertainment1Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import entertainment1Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import entertainment1Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import entertainment1Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import entertainment2 from '../assets/Vendor/Vendors/Entertainment/Entertainment-2.jpg';
import entertainment2Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import entertainment2Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import entertainment2Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import entertainment2Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import entertainment2Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import entertainment2Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import entertainment2Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import entertainment2Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import entertainment2Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import entertainment2Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import entertainment2Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import entertainment3 from '../assets/Vendor/Vendors/Entertainment/Entertainment-3.jpg';
import entertainment3Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import entertainment3Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import entertainment3Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import entertainment3Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import entertainment3Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import entertainment3Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import entertainment3Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import entertainment3Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import entertainment3Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import entertainment3Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import entertainment3Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

import entertainment4 from '../assets/Vendor/Vendors/Entertainment/Entertainment-4.jpg';
import entertainment4Gallery1 from '../assets/Vendor/Gallery/1.jpg';
import entertainment4Gallery2 from '../assets/Vendor/Gallery/2.jpg';
import entertainment4Gallery3 from '../assets/Vendor/Gallery/3.jpg';
import entertainment4Gallery4 from '../assets/Vendor/Gallery/4.jpg';
import entertainment4Gallery5 from '../assets/Vendor/Gallery/5.jpg';
import entertainment4Gallery6 from '../assets/Vendor/Gallery/6.jpg';
import entertainment4Gallery7 from '../assets/Vendor/Gallery/7.jpg';
import entertainment4Gallery8 from '../assets/Vendor/Gallery/8.jpg';
import entertainment4Gallery9 from '../assets/Vendor/Gallery/9.jpg';
import entertainment4Review1 from '../assets/Vendor/Reviews/Pic-1.jpg';
import entertainment4Review2 from '../assets/Vendor/Reviews/Pic-2.jpg';

/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';


/*Events*/
import event1 from '../assets/Event/Events/Event-1.jpg';
import event1Gallery1 from '../assets/Event/Gallery/1.jpg';
import event1Gallery2 from '../assets/Event/Gallery/2.jpg';
import event1Gallery3 from '../assets/Event/Gallery/3.jpg';
import event1Gallery4 from '../assets/Event/Gallery/4.jpg';
import event1Gallery5 from '../assets/Event/Gallery/5.jpg';
import event1Gallery6 from '../assets/Event/Gallery/6.jpg';

import event2 from '../assets/Event/Events/Event-2.jpg';
import event2Gallery1 from '../assets/Event/Gallery/1.jpg';
import event2Gallery2 from '../assets/Event/Gallery/2.jpg';
import event2Gallery3 from '../assets/Event/Gallery/3.jpg';
import event2Gallery4 from '../assets/Event/Gallery/4.jpg';
import event2Gallery5 from '../assets/Event/Gallery/5.jpg';
import event2Gallery6 from '../assets/Event/Gallery/6.jpg';

import event3 from '../assets/Event/Events/Event-3.jpg';
import event3Gallery1 from '../assets/Event/Gallery/1.jpg';
import event3Gallery2 from '../assets/Event/Gallery/2.jpg';
import event3Gallery3 from '../assets/Event/Gallery/3.jpg';
import event3Gallery4 from '../assets/Event/Gallery/4.jpg';
import event3Gallery5 from '../assets/Event/Gallery/5.jpg';
import event3Gallery6 from '../assets/Event/Gallery/6.jpg';

import event4 from '../assets/Event/Events/Event-4.jpg';
import event4Gallery1 from '../assets/Event/Gallery/1.jpg';
import event4Gallery2 from '../assets/Event/Gallery/2.jpg';
import event4Gallery3 from '../assets/Event/Gallery/3.jpg';
import event4Gallery4 from '../assets/Event/Gallery/4.jpg';
import event4Gallery5 from '../assets/Event/Gallery/5.jpg';
import event4Gallery6 from '../assets/Event/Gallery/6.jpg';

import event5 from '../assets/Event/Events/Event-5.jpg';
import event5Gallery1 from '../assets/Event/Gallery/1.jpg';
import event5Gallery2 from '../assets/Event/Gallery/2.jpg';
import event5Gallery3 from '../assets/Event/Gallery/3.jpg';
import event5Gallery4 from '../assets/Event/Gallery/4.jpg';
import event5Gallery5 from '../assets/Event/Gallery/5.jpg';
import event5Gallery6 from '../assets/Event/Gallery/6.jpg';

import event6 from '../assets/Event/Events/Event-6.jpg';
import event6Gallery1 from '../assets/Event/Gallery/1.jpg';
import event6Gallery2 from '../assets/Event/Gallery/2.jpg';
import event6Gallery3 from '../assets/Event/Gallery/3.jpg';
import event6Gallery4 from '../assets/Event/Gallery/4.jpg';
import event6Gallery5 from '../assets/Event/Gallery/5.jpg';
import event6Gallery6 from '../assets/Event/Gallery/6.jpg';

/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog11 from '../assets/Blog/Blogs/Blog-11.jpg';
import blog11Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog11Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog11Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog11Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog11Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog12 from '../assets/Blog/Blogs/Blog-12.jpg';
import blog12Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog12Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog12Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog12Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog12Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/10.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/10.jpg';
import product8Gallery4 from '../assets/Shop/Products/11.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*Partners*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,

    /*About*/
    about1,
    about2,

    /*Process*/
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,

    /*Pricing*/
    plan1,
    plan2,
    plan3,

    /*Team*/
    team1,
    team2,
    team3, 
    team4,

    /*Testimonials*/
    testimonialImage,
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*FAQs*/ 
    FAQs,

    /*Gallery*/
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,

    /*Career Introduction*/
    careerIntro,

    /*Positions*/
    position1,
    position2,
    position3,
    position4,
    position5,
    position6,

    /*Vendors*/
    floral1,
    floral1Gallery1,
    floral1Gallery2,
    floral1Gallery3,
    floral1Gallery4,
    floral1Gallery5,
    floral1Gallery6,
    floral1Gallery7,
    floral1Gallery8,
    floral1Gallery9,
    floral1Review1,
    floral1Review2,

    floral2,
    floral2Gallery1,
    floral2Gallery2,
    floral2Gallery3,
    floral2Gallery4,
    floral2Gallery5,
    floral2Gallery6,
    floral2Gallery7,
    floral2Gallery8,
    floral2Gallery9,
    floral2Review1,
    floral2Review2,

    floral3,
    floral3Gallery1,
    floral3Gallery2,
    floral3Gallery3,
    floral3Gallery4,
    floral3Gallery5,
    floral3Gallery6,
    floral3Gallery7,
    floral3Gallery8,
    floral3Gallery9,
    floral3Review1,
    floral3Review2,

    floral4,
    floral4Gallery1,
    floral4Gallery2,
    floral4Gallery3,
    floral4Gallery4,
    floral4Gallery5,
    floral4Gallery6,
    floral4Gallery7,
    floral4Gallery8,
    floral4Gallery9,
    floral4Review1,
    floral4Review2,

    catering1,
    catering1Gallery1,
    catering1Gallery2,
    catering1Gallery3,
    catering1Gallery4,
    catering1Gallery5,
    catering1Gallery6,
    catering1Gallery7,
    catering1Gallery8,
    catering1Gallery9,
    catering1Review1,
    catering1Review2,

    catering2,
    catering2Gallery1,
    catering2Gallery2,
    catering2Gallery3,
    catering2Gallery4,
    catering2Gallery5,
    catering2Gallery6,
    catering2Gallery7,
    catering2Gallery8,
    catering2Gallery9,
    catering2Review1,
    catering2Review2,

    catering3,
    catering3Gallery1,
    catering3Gallery2,
    catering3Gallery3,
    catering3Gallery4,
    catering3Gallery5,
    catering3Gallery6,
    catering3Gallery7,
    catering3Gallery8,
    catering3Gallery9,
    catering3Review1,
    catering3Review2,

    catering4,
    catering4Gallery1,
    catering4Gallery2,
    catering4Gallery3,
    catering4Gallery4,
    catering4Gallery5,
    catering4Gallery6,
    catering4Gallery7,
    catering4Gallery8,
    catering4Gallery9,
    catering4Review1,
    catering4Review2,

    photography1,
    photography1Gallery1,
    photography1Gallery2,
    photography1Gallery3,
    photography1Gallery4,
    photography1Gallery5,
    photography1Gallery6,
    photography1Gallery7,
    photography1Gallery8,
    photography1Gallery9,
    photography1Review1,
    photography1Review2,

    photography2,
    photography2Gallery1,
    photography2Gallery2,
    photography2Gallery3,
    photography2Gallery4,
    photography2Gallery5,
    photography2Gallery6,
    photography2Gallery7,
    photography2Gallery8,
    photography2Gallery9,
    photography2Review1,
    photography2Review2,

    photography3,
    photography3Gallery1,
    photography3Gallery2,
    photography3Gallery3,
    photography3Gallery4,
    photography3Gallery5,
    photography3Gallery6,
    photography3Gallery7,
    photography3Gallery8,
    photography3Gallery9,
    photography3Review1,
    photography3Review2,

    photography4,
    photography4Gallery1,
    photography4Gallery2,
    photography4Gallery3,
    photography4Gallery4,
    photography4Gallery5,
    photography4Gallery6,
    photography4Gallery7,
    photography4Gallery8,
    photography4Gallery9,
    photography4Review1,
    photography4Review2,

    venue1,
    venue1Gallery1,
    venue1Gallery2,
    venue1Gallery3,
    venue1Gallery4,
    venue1Gallery5,
    venue1Gallery6,
    venue1Gallery7,
    venue1Gallery8,
    venue1Gallery9,
    venue1Review1,
    venue1Review2,

    venue2,
    venue2Gallery1,
    venue2Gallery2,
    venue2Gallery3,
    venue2Gallery4,
    venue2Gallery5,
    venue2Gallery6,
    venue2Gallery7,
    venue2Gallery8,
    venue2Gallery9,
    venue2Review1,
    venue2Review2,

    venue3,
    venue3Gallery1,
    venue3Gallery2,
    venue3Gallery3,
    venue3Gallery4,
    venue3Gallery5,
    venue3Gallery6,
    venue3Gallery7,
    venue3Gallery8,
    venue3Gallery9,
    venue3Review1,
    venue3Review2,

    venue4,
    venue4Gallery1,
    venue4Gallery2,
    venue4Gallery3,
    venue4Gallery4,
    venue4Gallery5,
    venue4Gallery6,
    venue4Gallery7,
    venue4Gallery8,
    venue4Gallery9,
    venue4Review1,
    venue4Review2,

    attire1,
    attire1Gallery1,
    attire1Gallery2,
    attire1Gallery3,
    attire1Gallery4,
    attire1Gallery5,
    attire1Gallery6,
    attire1Gallery7,
    attire1Gallery8,
    attire1Gallery9,
    attire1Review1,
    attire1Review2,

    attire2,
    attire2Gallery1,
    attire2Gallery2,
    attire2Gallery3,
    attire2Gallery4,
    attire2Gallery5,
    attire2Gallery6,
    attire2Gallery7,
    attire2Gallery8,
    attire2Gallery9,
    attire2Review1,
    attire2Review2,

    attire3,
    attire3Gallery1,
    attire3Gallery2,
    attire3Gallery3,
    attire3Gallery4,
    attire3Gallery5,
    attire3Gallery6,
    attire3Gallery7,
    attire3Gallery8,
    attire3Gallery9,
    attire3Review1,
    attire3Review2,

    attire4,
    attire4Gallery1,
    attire4Gallery2,
    attire4Gallery3,
    attire4Gallery4,
    attire4Gallery5,
    attire4Gallery6,
    attire4Gallery7,
    attire4Gallery8,
    attire4Gallery9,
    attire4Review1,
    attire4Review2,

    entertainment1,
    entertainment1Gallery1,
    entertainment1Gallery2,
    entertainment1Gallery3,
    entertainment1Gallery4,
    entertainment1Gallery5,
    entertainment1Gallery6,
    entertainment1Gallery7,
    entertainment1Gallery8,
    entertainment1Gallery9,
    entertainment1Review1,
    entertainment1Review2,

    entertainment2,
    entertainment2Gallery1,
    entertainment2Gallery2,
    entertainment2Gallery3,
    entertainment2Gallery4,
    entertainment2Gallery5,
    entertainment2Gallery6,
    entertainment2Gallery7,
    entertainment2Gallery8,
    entertainment2Gallery9,
    entertainment2Review1,
    entertainment2Review2,

    entertainment3,
    entertainment3Gallery1,
    entertainment3Gallery2,
    entertainment3Gallery3,
    entertainment3Gallery4,
    entertainment3Gallery5,
    entertainment3Gallery6,
    entertainment3Gallery7,
    entertainment3Gallery8,
    entertainment3Gallery9,
    entertainment3Review1,
    entertainment3Review2,

    entertainment4,
    entertainment4Gallery1,
    entertainment4Gallery2,
    entertainment4Gallery3,
    entertainment4Gallery4,
    entertainment4Gallery5,
    entertainment4Gallery6,
    entertainment4Gallery7,
    entertainment4Gallery8,
    entertainment4Gallery9,
    entertainment4Review1,
    entertainment4Review2,

    /*Services*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*Events*/
    event1,
    event1Gallery1,
    event1Gallery2,
    event1Gallery3,
    event1Gallery4,
    event1Gallery5,
    event1Gallery6,

    event2,
    event2Gallery1,
    event2Gallery2,
    event2Gallery3,
    event2Gallery4,
    event2Gallery5,
    event2Gallery6,

    event3,
    event3Gallery1,
    event3Gallery2,
    event3Gallery3,
    event3Gallery4,
    event3Gallery5,
    event3Gallery6,

    event4,
    event4Gallery1,
    event4Gallery2,
    event4Gallery3,
    event4Gallery4,
    event4Gallery5,
    event4Gallery6,

    event5,
    event5Gallery1,
    event5Gallery2,
    event5Gallery3,
    event5Gallery4,
    event5Gallery5,
    event5Gallery6,

    event6,
    event6Gallery1,
    event6Gallery2,
    event6Gallery3,
    event6Gallery4,
    event6Gallery5,
    event6Gallery6,

    /*Portfolios*/
    portfolio1,
    portfolio1Gallery1,
    portfolio1Gallery2,
    portfolio1Gallery3,
    portfolio1Gallery4,
    portfolio1Gallery5,
    portfolio1Gallery6,

    portfolio2,
    portfolio2Gallery1,
    portfolio2Gallery2,
    portfolio2Gallery3,
    portfolio2Gallery4,
    portfolio2Gallery5,
    portfolio2Gallery6,

    portfolio3,
    portfolio3Gallery1,
    portfolio3Gallery2,
    portfolio3Gallery3,
    portfolio3Gallery4,
    portfolio3Gallery5,
    portfolio3Gallery6,

    portfolio4,
    portfolio4Gallery1,
    portfolio4Gallery2,
    portfolio4Gallery3,
    portfolio4Gallery4,
    portfolio4Gallery5,
    portfolio4Gallery6,

    portfolio5,
    portfolio5Gallery1,
    portfolio5Gallery2,
    portfolio5Gallery3,
    portfolio5Gallery4,
    portfolio5Gallery5,
    portfolio5Gallery6,

    portfolio6,
    portfolio6Gallery1,
    portfolio6Gallery2,
    portfolio6Gallery3,
    portfolio6Gallery4,
    portfolio6Gallery5,
    portfolio6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    blog11,
    blog11Gallery1,
    blog11Gallery2,
    blog11Comment1,
    blog11Comment2,
    blog11Comment3,

    blog12,
    blog12Gallery1,
    blog12Gallery2,
    blog12Comment1,
    blog12Comment2,
    blog12Comment3,

    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

};

export default images;